import useSWRGas from "./useSWRGas";
import { resolveGasBalanceBudget } from "./resolveGasBalanceBudget";
const useOutOfGas = ({ address, network, token, amount, balances, minAllowedAmount, maxAllowedAmount, transaction, gasEstimate, }) => {
    const { gasData: fetchedGas } = useSWRGas(address, network, token, amount, undefined, { transaction, enabled: gasEstimate === undefined });
    const gasData = gasEstimate ? gasEstimate.gasData : fetchedGas;
    const nativeTokenBalance = balances?.find(b => b.token === network?.token?.symbol);
    const balance = nativeTokenBalance?.amount;
    const isNativeToken = nativeTokenBalance?.isNativeCurrency && token?.symbol === network?.token?.symbol;
    if (balance == null || !gasData || !amount || !isNativeToken || minAllowedAmount == null || maxAllowedAmount == null) {
        return { outOfGas: false };
    }
    const numAmount = Number(amount);
    const gasAndReserve = resolveGasBalanceBudget(gasData);
    const totalNeeded = numAmount + gasAndReserve;
    const balanceCoversAmount = numAmount <= balance;
    const balanceExceedsMaxWithGas = balance > (maxAllowedAmount + gasAndReserve);
    const balanceAboveMin = balance > minAllowedAmount;
    const outOfGas = totalNeeded > balance
        && balanceCoversAmount
        && balanceAboveMin
        && !balanceExceedsMaxWithGas;
    return { outOfGas };
};
export default useOutOfGas;
